export default __webpack_public_path__ + "static/media/no_in_icon.f655b2e4.svg";